/* ============================================================
   Long Run Co. Member Portal RUN-LOW FORECAST ENGINE
   Read-only. On portal load it POSTs:
     /apps/lrc {action:'get_forecast'} -> { forecast:[...] }   (real platform dates + intervals per contract)
     /apps/lrc {action:'get_member'}   -> { member:{ usage } } (saved quiz servingsPerDay per category)
   plus window.LRC_PRODUCT_MAP (Liquid metafields, keyed by numeric product id).

   It reads REAL platform dates (nextBillingDate, lastOrderDate) and intervals, computes the shipping-axis
   run-low forecast per active contract on calendar dates (time-of-day ignored), then EXPOSES the results for
   the timeline renderer (assets/lrc-mp-subscription.js) on a shared object keyed by contractId and dispatches
   'lrc:forecast-ready'. It renders no UI of its own. Timing comes from window.LRC_FORECAST_CFG.timing.
   No em or en dashes in copy.
   ============================================================ */
(function () {
  "use strict";
  if (window.__LRC_FORECAST_RAN) return;
  window.__LRC_FORECAST_RAN = true;

  var DAY = 86400000;

  /* ---- /apps/lrc (mirrors the quiz postLRC: same-origin, JSON, treats j.ok===false as failure) ---- */
  function postLRC(payload) {
    return fetch("/apps/lrc", {
      method: "POST", credentials: "same-origin",
      headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload)
    }).then(function (r) { return r.json().catch(function () { return null; }); });
  }

  /* ---- helpers ---- */
  function num(v) { var n = parseFloat(v); return isFinite(n) ? n : null; }
  function numOr(v, d) { var n = num(v); return n == null ? d : n; }
  function stripId(pid) { var s = String(pid == null ? "" : pid).replace(/[^0-9]/g, ""); return s || null; }
  function cfg() { return (window.LRC_FORECAST_CFG && typeof window.LRC_FORECAST_CFG === "object") ? window.LRC_FORECAST_CFG : {}; }

  function productMap() {
    if (window.LRC_PRODUCT_MAP && typeof window.LRC_PRODUCT_MAP === "object") return window.LRC_PRODUCT_MAP;
    var el = document.getElementById("lrc-product-map");
    if (el) { try { return JSON.parse(el.textContent || "{}"); } catch (e) {} }
    return {};
  }

  /* ---- calendar-date helpers (time-of-day ignored; local midnight) ---- */
  function toDate(v) {
    if (v == null || v === "") return null;
    var d = (typeof v === "number") ? new Date(v < 1e12 ? v * 1000 : v) : new Date(v);
    return isNaN(d.getTime()) ? null : d;
  }
  function atMid(d) { return d ? new Date(d.getFullYear(), d.getMonth(), d.getDate()) : null; }
  function addDays(d, n) { return atMid(new Date(d.getTime() + Math.round(n) * DAY)); }
  /* full ISO of a local-midnight date round-trips back to the same local day in the same browser TZ */
  function iso(d) { return d ? d.toISOString() : null; }

  var TODAY = atMid(new Date());

  /* ---- per active contract: read real dates, derive shipping schedule + run-low on calendar dates ---- */
  function computeOne(ct, usage, pmap, T) {
    if (String(ct.status || "").toLowerCase() !== "active") return null;   /* skip non-active */

    var bi = num(ct.billingIntervalDays);
    var di = num(ct.deliveryIntervalDays);
    var isPrepaid = (typeof ct.isPrepaid === "boolean") ? ct.isPrepaid : (bi != null && di != null && bi > di);

    var nextBilling = atMid(toDate(ct.nextBillingDate));
    if (!nextBilling) return null;   /* invalid next billing -> no forecast for this contract */

    /* FORWARD: next order/ship date */
    var nextDelivery;
    if (!isPrepaid) {
      nextDelivery = nextBilling;
    } else {
      var nd = nextBilling;
      if (di > 0) { while (addDays(nd, -di).getTime() > TODAY.getTime()) nd = addDays(nd, -di); }
      nextDelivery = nd;
    }
    var shipDate = nextDelivery;
    var arriveDate = addDays(shipDate, T.transitMax);

    /* LAST DELIVERY: run-low anchor */
    var gridPrev = (di > 0) ? addDays(nextDelivery, -di) : null;
    var lod = atMid(toDate(ct.lastOrderDate));
    var lastDelivery;
    if (lod) {
      lastDelivery = lod;
      if (isPrepaid && gridPrev && gridPrev.getTime() > lastDelivery.getTime()) lastDelivery = gridPrev;
    } else {
      lastDelivery = gridPrev;
    }
    var isNew = (!lastDelivery) || (lastDelivery.getTime() > TODAY.getTime());

    /* CONSUMPTION: on-hand servings + rate per category */
    var onHandByCat = {};
    (ct.lineItems || []).forEach(function (li) {
      var pid = stripId(li.productId);
      var entry = pid ? pmap[pid] : null;
      if (!entry) return;
      var cat = (entry.category != null) ? String(entry.category).trim().toLowerCase() : null;
      var upb = num(entry.units_per_bag);
      var qty = num(li.quantity) || 0;
      if (cat && upb != null && upb > 0) onHandByCat[cat] = (onHandByCat[cat] || 0) + qty * upb;
    });
    var rateByCat = {};
    if (usage && typeof usage === "object") {
      Object.keys(usage).forEach(function (k) {
        var nk = String(k).trim().toLowerCase();
        var r = usage[k] ? num(usage[k].servingsPerDay) : null;
        if (r != null) rateByCat[nk] = r;
      });
    }

    var runLowByCat = {}, missingRate = false, earliest = null, binding = null;
    Object.keys(onHandByCat).forEach(function (cat) {
      if (!(onHandByCat[cat] > 0)) return;
      var rate = rateByCat[cat];
      if (rate == null || !(rate > 0)) { missingRate = true; return; }
      if (!lastDelivery) return;
      var rl = addDays(lastDelivery, onHandByCat[cat] / rate);
      runLowByCat[cat] = rl;
      if (!earliest || rl.getTime() < earliest.getTime()) { earliest = rl; binding = cat; }
    });

    var nextNextDelivery = (di > 0) ? addDays(arriveDate, di) : null;

    /* STATE */
    var state, runLowDate;
    var anyRunLow = Object.keys(runLowByCat).length > 0;
    if (isNew) { state = "new"; runLowDate = null; }
    else if (!anyRunLow && missingRate) { state = "no-rate"; runLowDate = null; }
    else if (earliest && earliest.getTime() <= addDays(arriveDate, T.shortBuffer).getTime()) { state = "short"; runLowDate = earliest; }
    else if (earliest && earliest.getTime() > addDays(arriveDate, T.overstockBuffer).getTime()) { state = "overstocked"; runLowDate = earliest; }
    else { state = "on-track"; runLowDate = earliest; }

    return {
      state: state,
      shipDate: iso(shipDate),
      arriveDate: iso(arriveDate),
      runLowDate: iso(runLowDate),
      bindingCategory: binding || null,
      nextNextDelivery: iso(nextNextDelivery)
    };
  }

  /* ---- output: shared object keyed by contractId + ready event (no DOM rendering) ---- */
  function publish(forecast, usage, pmap, T) {
    var byContract = {};
    (forecast || []).forEach(function (ct) {
      var r = computeOne(ct, usage, pmap, T);
      if (r) byContract[String(ct.contractId)] = r;
    });
    window.LRC_FORECAST_BY_CONTRACT = byContract;
    window.LRC_FORECAST_READY = true;
    try { document.dispatchEvent(new CustomEvent("lrc:forecast-ready")); } catch (e) {}
  }

  function buildT() {
    var t = (cfg().timing) || {};
    return { transitMax: numOr(t.transit_max, 5), shortBuffer: numOr(t.short_buffer_days, 2), overstockBuffer: numOr(t.overstock_buffer_days, 14) };
  }
  /* Shared, re-runnable fetch+compute+publish. Always re-fetches get_forecast; re-fetches get_member only when
     opts.member===true (item edits reuse the last usage; quiz saves pass {member:true}). Returns the parsed
     get_forecast result so callers can verify Appstle propagation; returns null (never throws) on failure. */
  var lastUsage = {};
  function runForecast(opts) {
    opts = opts || {};
    var fetchMember = (opts.member === true);
    var T = buildT();
    var calls = [postLRC({ action: "get_forecast" })];
    if (fetchMember) calls.push(postLRC({ action: "get_member" }));
    return Promise.all(calls).then(function (arr) {
      var fc = arr[0];
      var forecast = (fc && fc.ok) ? (fc.forecast || []) : null;
      if (fetchMember) { var mem = arr[1]; lastUsage = (mem && mem.ok && mem.member && mem.member.usage) || {}; }
      if (forecast == null) { if (window.console) console.warn("[lrc-forecast] get_forecast failed; timeline unchanged."); return null; }
      window.LRC_FORECAST_RAW = fc;   /* raw payload (incl. per-contract lineItems) so the renderer can detect line changes */
      publish(forecast, lastUsage, productMap(), T);
      return fc;
    }).catch(function (e) { if (window.console) console.warn("[lrc-forecast] fetch threw:", e); return null; });
  }

  /* Re-runnable refresh entry point. Bypasses the __LRC_FORECAST_RAN one-shot guard (that guard only gates the
     AUTO first run below, not manual refreshes). */
  window.LRCMP_FORECAST = window.LRCMP_FORECAST || {};
  window.LRCMP_FORECAST.refresh = function (opts) { return runForecast(opts); };

  /* ---- init: AUTO first run, only when the subscription section is on the page ---- */
  function start() {
    if (!document.querySelector("[data-lrc-mp-subscription]")) return;
    runForecast({ member: true });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start); else start();
})();
